import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-holdon",
  "use": "icon-holdon-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-holdon\"><path d=\"M512 916.096A404.112 404.112 0 1 1 916.096 512 404.096 404.096 0 0 1 512 916.096z m40.416-404.112V309.936h-80.832v282.88h242.464V512z\" fill=\"#2781F8\" p-id=\"2912\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol